import { observable, computed, action, decorate, runInAction } from 'mobx';
import ContentService from '../services/Content.service';
import CompaniesStore from './Companies';
import { console } from 'window-or-global';

class ContentStore {
  content = null;
  initialFetchDone = observable.box(false);

  transformData = data => {
    let filtredData = data.filter(value => value[0]);
    let transformedObject = [];

    filtredData.map(i =>
      transformedObject.push({
        label: `${i[0]}`,
        value: Number(i[1])
      })
    );

    return transformedObject;
  };

  incomeDynamicsDataTransformer(data) {
    let incomeDynamicsData = [];
    let clearedData = data.filter(value => value);

    const countPercent = (value, countPercentFromValue) => {
      let percentageValue = (countPercentFromValue / value) * 100 - 100;
      return Math.round(percentageValue);
    };
    let firstYearCounted = 0;
    let currentYear = clearedData.length - 1;
    let previousYear = clearedData.length - 2;

    incomeDynamicsData.push({
      label: `${clearedData[previousYear].label} / ${
        clearedData[currentYear].label
      }`,
      value: `${countPercent(
        clearedData[previousYear].value,
        clearedData[currentYear].value
      )}%`
    });

    previousYear !== firstYearCounted &&
      incomeDynamicsData.push({
        label: `${clearedData[firstYearCounted].label} / ${
          clearedData[currentYear].label
        }`,
        value: `${countPercent(
          clearedData[firstYearCounted].value,
          clearedData[currentYear].value
        )}%`
      });

    return incomeDynamicsData;
  }

  get isLoaded() {
    return this.initialFetchDone.get();
  }

  async fetchContent() {
    try {
      const items = await ContentService.fetchContent();
      if (items.isEmpty) {
        return;
      }

      const content = items.firstItem;

      runInAction(() => {
        this.content = content;
        CompaniesStore.setCompanies(content.companies);
        this.initialFetchDone.set(true);
      });
      return this.content;
    } catch (e) {
      console.error('Failed to fetch content data', e);
      return null;
    }
  }
}

decorate(ContentStore, {
  content: observable,
  isLoaded: computed,
  fetchContent: action
});

export default new ContentStore();



// WEBPACK FOOTER //
// ./src/stores/Content.store.js